import { ChronicDiseaseSimpleQuery } from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCount } from '@dreryk/command-query-react-common';
import { createInterpolatedTranslationKey, Translate, useTranslate } from '@dreryk/react-common';

import {
   medicalDocumentationCreateTranslationKeys,
   patientMedicalInformationTranslationKeys,
} from '../../translations';
import { useShowRemovedMedicalInformationState } from '../MedicalInformationShowRemovedCheckbox.hooks';

const TRANSLATION_KEY = medicalDocumentationCreateTranslationKeys.categories.CHRONIC_DISEASE;

type ChronicMedicalInformationAccordionSectionLabelProps = {
   readonly patientId: number;
};

export const ChronicMedicalInformationAccordionSectionLabel = (
   props: ChronicMedicalInformationAccordionSectionLabelProps
): JSX.Element => {
   const [showRemoved] = useShowRemovedMedicalInformationState();

   const translate = useTranslate();
   const { data: chronicDiseaseCount } = useCqrsCount(() => {
      const query = new ChronicDiseaseSimpleQuery();
      query.patientId = props.patientId;
      query.showRemoved = showRemoved;
      return query;
   });

   if (chronicDiseaseCount) {
      return (
         <Translate>
            {createInterpolatedTranslationKey(patientMedicalInformationTranslationKeys.sectionName, {
               name: translate(TRANSLATION_KEY),
               count: chronicDiseaseCount,
            })}
         </Translate>
      );
   }

   return <Translate>{TRANSLATION_KEY}</Translate>;
};
